import { Component, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import { BaseChartComponent } from '../basechart/basechart.component';

@Component({
  selector: 'app-securitynavigator',
  templateUrl: '../basechart/basechart.component.html',
})
export class SecurityNavigatorComponent extends BaseChartComponent<Array<Highcharts.SeriesPieOptions>> {

  @Input() subtitle: string;

  options: Highcharts.Options = {
    chart: {
      type: 'pie',
      height: '145%',
      width: 200,
    },
    title: {
      text: '',
      verticalAlign: 'bottom',
      floating: true
    },
    subtitle: {
      text: '',
      floating: true,
      verticalAlign: 'middle',
      style: {
        fontWeight: 'bold',
        font: 'bold 24px "Trebuchet MS", Verdana, sans-serif',
      },
    },
    plotOptions: {
      pie: {
        size: 180,
        allowPointSelect: false,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        innerSize: '70%',
        borderColor: null,
        enableMouseTracking: false
      }
    },
    series: undefined
  };

  draw(renderingId: string) {
    this.options.title.text = this.title;
    this.options.series = this.data;
    this.options.subtitle.text = this.subtitle;
  }
}
